import { apiFetch } from './client';

export interface AttrSchemaField {
  key: string;
  label: string;
  multi: boolean;
  family: string;
  options?: string[];
}

export interface ItemAttrs {
  cloth_id: string;
  id_type: 'cloth' | 'item';
  name: string;
  category: string;
  description: string;
  thumb: string;
  family: 'clothing' | 'footwear' | 'accessories' | string;
  attrs: Record<string, string[]>;
  schema: AttrSchemaField[];
}

export async function getItemAttrs(virtualUserId: string, clothId: string): Promise<ItemAttrs> {
  return apiFetch(
    `/v1/virtual-users/${encodeURIComponent(virtualUserId)}/wardrobe-items/${encodeURIComponent(clothId)}/attrs`
  );
}

export async function updateItemAttrs(
  virtualUserId: string,
  clothId: string,
  body: {
    name?: string;
    description?: string;
    attrs: Record<string, string[]>;
  }
): Promise<ItemAttrs> {
  return apiFetch(
    `/v1/virtual-users/${encodeURIComponent(virtualUserId)}/wardrobe-items/${encodeURIComponent(clothId)}/attrs`,
    { method: 'PUT', body: JSON.stringify(body) }
  );
}

export async function getAttrSchema(): Promise<{ fields: AttrSchemaField[] }> {
  return apiFetch('/v1/attr-schema');
}
